import {useAuth0} from "@auth0/auth0-react";
export const useLogout = () => {
  const {logout} = useAuth0();
  const handleLogout = async () => {
    logout({logoutParams: {returnTo: `${window.location.origin}/auth/logout`}});
  };
  return {logout: handleLogout};
};
